var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { StaticCircles } from '../Circles/StaticCircles';
export function StartButton(_a) {
    var onClick = _a.onClick, color = _a.color, buttonStyles = _a.buttonStyles, progress = _a.progress, _b = _a.size, size = _b === void 0 ? 7 : _b, _c = _a.GraphicElement, GraphicElement = _c === void 0 ? StaticCircles : _c, _d = _a.graphicElementProps, graphicElementProps = _d === void 0 ? {} : _d, children = _a.children;
    var colorString = typeof color === 'string' ? color : color.main;
    var sizeString = typeof size === 'string' ? size : "".concat(size, "rem");
    var textColor = typeof color === 'string' ? 'inherit' : color.contrastText;
    var isLoading = progress && progress !== 100;
    return (_jsxs("div", __assign({ className: "grid min-h-full place-items-center" }, { children: [_jsx("div", __assign({ role: "status", className: "sr-only" }, { children: isLoading ? 'loading' : '' })), _jsx(GraphicElement, __assign({ color: colorString, size: size }, graphicElementProps, { children: _jsx(RoundButton, __assign({ onClick: onClick, style: __assign({ minHeight: sizeString, minWidth: sizeString, backgroundColor: colorString, color: textColor }, buttonStyles) }, { children: _jsx("span", __assign({ role: "progressbar", "aria-label": "Loading", "aria-valuenow": (progress || 0) }, { children: progress && progress !== 100
                            ? "".concat(progress, "%")
                            : children || 'start' })) })) }))] })));
}
export default StartButton;
var RoundButton = styled(Button)(function () { return ({
    borderRadius: '9999px',
    fontSize: '1rem',
    fontWeight: 'bold',
    '&&:hover': {
        color: 'white',
    },
}); });
